import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: {
    items: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0,
    links: [],
    itemsCount: 0,
    totalPrice: 0,
  },
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cart = { ...state.cart, ...action.payload };
    },

    setCartItemsCount: (state, action) => {
      state.cart.itemsCount = action.payload;
    },

    incrementCartCount: (state, action) => {
      state.cart.itemsCount += action.payload || 1;
    },

    decrementCartCount: (state, action) => {
      state.cart.itemsCount -= action.payload || 1;
      if (state.cart.itemsCount < 0) {
        state.cart.itemsCount = 0;
      }
    },

    updateCartItemQuantity: (state, action) => {
      const { id, change } = action.payload;

      const item = state.cart.items.find((i) => i.id === id);
      if (!item) return;

      const maxQty = item.stock ?? 1;
      const nextQty = (item.quantity ?? maxQty) + change;

      if (nextQty < 1 || nextQty > maxQty) return;

      item.quantity = nextQty;

      // 🔄 Recalculate totals
      state.cart.itemsCount = state.cart.items.reduce(
        (sum, i) => sum + i.quantity,
        0,
      );

      state.cart.totalPrice = state.cart.items.reduce(
        (sum, i) => sum + i.quantity * i.price,
        0,
      );
    },

    setTotalPrice: (state, action) => {
      state.cart.totalPrice = action.payload;
    },

    setBalance: (state, action) => {
      state.cart.balance = action.payload;
    },

    resetCart: (state) => {
      state.cart = initialState.cart;
    },
  },
});

export const {
  setCart,
  resetCart,
  setBalance,
  setTotalPrice,
  setCartItemsCount,
  incrementCartCount,
  decrementCartCount,
  updateCartItemQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;
